import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

import OneAsyncSelectToRuleThemAll from '../../../shared/components/one_async_select_to_rule_them_all.jsx'

class SearchUsers extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      value: props.value || null, // Store full option object, not just ID
      loadedOptions: [] //Keep track of loaded options
    }
  }

  getUsers = (input) => {
    return fetch(`${this.props.loadPath}?search=${input || ""}`, { credentials: 'same-origin' }).
      then((response) => {
        return response.json();
      }).
      then((json) => {
        const options = json.map((option) => {
          return {
            value: option.id,
            label: `${option.first_name} ${option.last_name}`,
            data: option
          }
        });
        this.setState({ loadedOptions: options });
        
        console.log("🔍 Loaded user options:", options);
        return options;
      });
  }

  onChange = (option) => {
    if(!option) { 
      this.setState({ value: null });
      return; 
    }
    this.setState({ value: option }, () => {
      this.props.onChange(option.data);
    })
  }

  render() {
    return (
      <OneAsyncSelectToRuleThemAll.Base
        labelText="Search for User"
        tabIndex={ this.props.tabIndex }
        value={ this.state.value }
        onChange={ this.onChange }
        loadOptions={ this.getUsers }
        valueKey="value"
        labelKey="display"
        simpleValue={ false }
        defaultOptions={ false }
        noOptionsMessage={ ({ inputValue }) => {
        return inputValue 
          ? "No users found" 
          : "Type to search..."
      }}    
      />
    )
  }
}

SearchUsers.propTypes = {
  loadPath: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,

  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])

}

SearchUsers = connect(
  (state, props) => ({
    loadPath: state.rails.asyncHelpers.users
  })
)(SearchUsers)

export default SearchUsers
